// extracted by mini-css-extract-plugin
export default {"btop":"_02d7100b78 f4df717837 _8eda1c9b46","icon":"ec66c3b1eb _0a9ec4effc","btoppink":"_4eaabeddce _4af21280da"};